import colors from '../colors';

const colorsTheme = {
  text: colors.White,
  background: colors.Shark,
  pushBackground: colors.Black,
  tooltipBackground: colors.LimedSpruce,
  modalBackground: colors.LimedSpruce,
};

export default colorsTheme;
